export const advertData = [
  {
    id: "",
    name: "",
    img: "",
  },
  {
    id: "",
    name: "",
    img: "",
  },
];

export const dealsData = [
  {
    id: "1",
    productImg: "/images/Products/samsungGalaxy.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB, 128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 100000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 4,
  },
  {
    id: "2",
    productImg: "/images/Products/shoe.png",
    productName: "Journeys Rainbow Vans Old School",
    detailedImages: {
      img1:
        "https://images.journeys.com/images/products/1_614890_ZM_ALT2.JPG?_ga=2.101147969.1762225677.1620076265-997436680.1620076265",
      img2:
        "https://images.journeys.com/images/products/1_614890_ZM_ALT3.JPG?_ga=2.31222399.1762225677.1620076265-997436680.1620076265",
    },
    mainPrice: 112000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "3",
    productImg: "/images/Products/laptop.png",
    productName: "Vostro 14 5000 Small Business Laptop",
    detailedImages: {
      img1:
        "https://images-na.ssl-images-amazon.com/images/I/51wPtHrYs9L._AC_SL1154_.jpg",
      img2:
        "https://images-na.ssl-images-amazon.com/images/I/715mRc4t10L._AC_SL1280_.jpg",
    },
    mainPrice: 110000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "4",
    productImg: "/images/Products/dress.png",
    productName: "Black and Blue Ombre Prom Dress",
    detailedImages: {
      img1:
        "https://www.dhresource.com/0x0/f2/albu/g2/M01/1C/B9/rBVaG1aXDPqAXRnEAADIdMBc3Lg253.jpg/fashion-gradient-ombre-prom-dresses-sweetheart.jpg",
      img2:
        "https://www.dhresource.com/0x0/f2/albu/g2/M00/6B/B1/rBVaG1aXDPqAQB0nAAB1r8wr7Eo086.jpg/fashion-gradient-ombre-prom-dresses-sweetheart.jpg",
    },
    mainPrice: 130000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "5",
    productImg: "/images/Products/fridge.png",
    productName:
      "SAMSUNG Family Hub RF56M9540SR/EU American-Style Smart Fridge Freezer - Real Stainless",
    detailedImages: {
      img1:
        "https://media.flixcar.com/f360cdn/Samsung-78307263-uk-french-door-rf56m9540sr-rf56m9540sr-eu-Silver-180795747Download-Source-preview.jpg",
      img2:
        "https://media.flixcar.com/f360cdn/Samsung-78307420-uk-french-door-rf56m9540sr-rf56m9540sr-eu-Silver-180795927Download-Source-preview.jpg",
    },
    mainPrice: 80000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 4,
  },
  {
    id: "6",
    productImg: "/images/Products/shoe.png",
    productName: "Journeys Rainbow Vans Old School",
    detailedImages: {
      img1:
        "https://images.journeys.com/images/products/1_614890_ZM_ALT2.JPG?_ga=2.101147969.1762225677.1620076265-997436680.1620076265",
      img2:
        "https://images.journeys.com/images/products/1_614890_ZM_ALT3.JPG?_ga=2.31222399.1762225677.1620076265-997436680.1620076265",
    },
    mainPrice: 90000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "7",
    productImg: "/images/phone790.png",
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
      detailedImages: {
        img1:
          "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
        img2:
          "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
      },
    mainPrice: 110000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "8",
    productImg: "/images/phone792.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 140000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "9",
    productImg: "/images/phone791.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 130000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "10",
    productImg: "/images/phone790.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 120000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "11",
    productImg: "/images/phone790.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 100000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "12",
    productImg: "/images/powerBank795.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 110000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "13",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 200000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "14",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 190000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "15",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 130000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "16",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 180000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "17",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 160000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
  {
    id: "18",
    productImg: "/images/samsungFrontBack.png",
    detailedImages: {
      img1:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/2.jpg?1080",
      img2:
        "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/79/377417/3.jpg?1085",
    },
    productName:
      "Samsung Galaxy A50 6.4-Inch (4GB,128GB ROM) Android 9 Pie, (25MP+5MP+ 8MP)+ 25MP 4000mAh 4G Dual SIM Smartphone - White",
    mainPrice: 190000,
    slashedPrice: 80000,
    percentDiscount: "20%",
    sellerName: "THE 4DX",
    rating: 5,
  },
];
